/**
 * Joins an array of strings with proper English grammar:
 * - Single item: "Apple"
 * - Two items: "Apple and Banana"
 * - Three+ items: "Apple, Banana, and Cherry"
 */
export const joinWithAnd = (items: string[]): string => {
  if (items.length === 0) {
    return '';
  }

  if (items.length === 1) {
    return items[0];
  }

  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }

  // Three or more items: "A, B, and C"
  const allButLast = items.slice(0, -1).join(', ');
  const last = items[items.length - 1];
  return `${allButLast}, and ${last}`;
};
